var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 681,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 475,
	"./assets/thewest-digital-hero-variation-a.jpg": 682,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 683,
	"./assets/thewest-digital-hero-variation-b.jpg": 2593,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 684,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2594,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 685,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2595,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 686,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2596,
	"./assets/thewest-digital-hero.jpg": 2597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2592;